module.exports = __webpack_public_path__ + "img/hero-vid-poster_en.9b48bf2.jpg";